// @ts-check
import React from 'react';
import ModalRouter from 'shared/containers/ModalRouter';
import InboundOrOutboundToggle from './InboundOrOutboundToggle';
import ExplainerModal from './ExplainerModal';
import styles from './InboundOrOutboundChooser.module.scss';

const modals = [{ name: 'inboundVsOutboundInfo', component: ExplainerModal }];

const InboundOrOutboundChooser = () => (
  <div className={styles.container}>
    <InboundOrOutboundToggle />
    <ModalRouter modals={modals} />
  </div>
);

export default InboundOrOutboundChooser;
